exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.table th[data-v-520a9048], table.table td[data-v-520a9048] {\n  padding: 1.5rem 1rem;\n}\n.staticSearchItem[data-v-520a9048] {\n  float: left;\n  width: 33.33%;\n  padding: 1rem 2rem;\n}\n\n", ""]);

// exports
